var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":_vm.viewBox,"aria-hidden":!_vm.title,"role":_vm.role}},[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('path',{attrs:{"d":_vm.path,"fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }